import InfiniteSearchableSelect from '../../../components/ui/SearchableSelect/InfiniteSearchableSelect';
import OnboardingSearchableSelect from './OnboardingSearchableSelect';
import { fetchProfileListPage, mapProfileToSelectOption } from '../../license-management/adapters/profileListAdapter';

const isSameProfile = (a, b) => String(a?.id) === String(b?.id);
const getProfileId = (option) => option?.id;
const getProfileLabel = (profile) => profile?.label || profile?.name || '';

export default function OnboardingProfileSearchableSelect({
  valueId = null,
  onChange,
  selectedProfile = null,
  enabled = true,
  pageSize = 20,
  extraParams,
  ...props
}) {
  return (
    <InfiniteSearchableSelect
      {...props}
      fetchPage={fetchProfileListPage}
      extraParams={extraParams}
      pageSize={pageSize}
      enabled={enabled}
      valueId={valueId}
      selectedSeed={selectedProfile}
      mapToOption={mapProfileToSelectOption}
      isSameOption={isSameProfile}
      getOptionId={getProfileId}
      getOptionLabel={getProfileLabel}
      isOptionEqualToValue={isSameProfile}
      onChange={onChange}
      SelectComponent={OnboardingSearchableSelect}
    />
  );
}
